import React, { useEffect, useReducer } from "react";
import { Form, Input, Button, message, Checkbox, Row, Col, Spin } from "antd";
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import * as actions from '../../actions/index';
import { object } from "prop-types";

const FormItem = Form.Item;

const initialState = {
    alumniPrivacyOptionsState: {
        sparkDirectoryOptOut: false,
        scoutingAmericaOptOut: false,
    },
    needToUpdate: false,
    enableSaveBtn: false
}

const privacyOptionsReducer = (state, action) => {
    let newState;
    switch (action.type) {
        case 'UpdateAlumniPrivacyOptionsState':
            newState = { ...state, alumniPrivacyOptionsState: action.privacysettingsOptions };
            console.log("New state:", newState); // Log the new state
            return newState;

        case 'needToUpdateState':
            newState = { ...state,  needToUpdate: action.needToUpdate };
            return newState;
        case 'enableSaveBtnState':
            newState = { ...state,  enableSaveBtn: action.enableSaveBtn };
            return newState;

        default:
            return { ...state }
    }
}
const AlumniPrivacyOptionsComponent = (props) => {
    const { getFieldDecorator, validateFields } = props.form;

    const [state, dispatch] = useReducer(privacyOptionsReducer, initialState);

    useEffect(() => {
        // if (!props.isLoadingPrivacySettings && (!props.privacysettingsOptions || Object.keys(props.privacysettingsOptions).length == 0)) {
            props.actions.getOrUpdateAlumniPrivacyOptions(props.personGUID ? props.personGUID : false);
        // }
    }, [])

    useEffect(() => {
        const privacysettingsOptions = props.privacysettingsOptions;
        if (privacysettingsOptions && Object.keys(privacysettingsOptions).length) {     
            console.log('useEffect***********');
            dispatch({ type: 'UpdateAlumniPrivacyOptionsState', privacysettingsOptions });
            dispatch({ type: 'needToUpdateState', needToUpdate: false });
            dispatch({ type: 'enableSaveBtnState', enableSaveBtn: false });
        }

    }, [props.privacysettingsOptions])

    const changePrivacyOption = (e, key) => {
        const options = { ...state.alumniPrivacyOptionsState, [key]: e.target.checked };
        let needToUpdate = false;

        for (const optionsKey in options) {
            if (options.hasOwnProperty(optionsKey)) {
                if (
                    (props.privacysettingsOptions[optionsKey] === null && options[optionsKey] === true) ||
                    (props.privacysettingsOptions[optionsKey] !== null && props.privacysettingsOptions[optionsKey] !== options[optionsKey])
                ) {
                    needToUpdate = true; // Values of the same key are different
                    break; // Break the loop since you found a difference
                }
            }
        }
    
        dispatch({ type: 'UpdateAlumniPrivacyOptionsState', privacysettingsOptions: options });
        dispatch({type: 'needToUpdateState', needToUpdate});
        dispatch({ type: 'enableSaveBtnState', enableSaveBtn: true  });
        if (!needToUpdate) {
            dispatch({ type: 'enableSaveBtnState', enableSaveBtn: false  });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                // Handle form submission, e.g., send data to the server
                console.log("Form values:", values);
                // message.success("Form submitted successfully!");
                const extendedProfileId = props.profileinfo.extendedProfile.filter(obj => obj.attributeId == "25")[0].extendedProfileId;
                const getOldPrivacySettings = props.profileinfo.extendedProfile.filter(obj => obj.attributeId == "17")[0];
                //to update privacySettings in my-profile page
                // Check if the old privacy setting is set to "hidden" (attributeVal: "100").
                if (getOldPrivacySettings.attributeVal === "100") {
                    // If hidden, update the privacy options and make the old privacy setting visible for other alumni.
                    // Note: This condition handles the case where the old privacy setting is hidden.
                    props.actions.updatePrivacyOptions_And_VisibleOldPrivacySettings(values, extendedProfileId, getOldPrivacySettings);
                }
                else props.actions.getOrUpdateAlumniPrivacyOptions(null, values, extendedProfileId); // It only update the new privacy options if the old privacy setting is already set to "visible,"               
            }
        });
    };

    return (
        <div className='widget-content margin-bottom-20'>
            <Row type="flex" justify="space-between">
                <div className='widget-header-text'>
                    My Privacy Settings
                </div>
            </Row>
            <Row className='widget-content-section' type="flex" justify="space-between" align="middle">

                <Form onSubmit={handleSubmit} className="alumni-ui width-100">
                    <div className='edit-mode my-profile'>
                        <div className='AddMembership'>
                            Scouting America maintains the Alumni Spark Directory ("Directory") for the purposes of facilitating interaction with Scouting America alumni and allowing alumni to update their records. The Directory is user ID and password protected and may be accessed by authenticated Scouting America alumni, Scouting America personnel, and other authorized users. Each user is responsible for all use of his/her name and passwords to gain access to the Directory and for the use of information as a result of such access. Each user acknowledges that responsibility and agrees not to share his/her password with any other person. Scouting America has taken precautions to secure the personal information available through the Directory. However, it is each user's responsibility and decision to what personal/contract information he/she wishes to be displayed in the Directory to other users.
                        </div>

                        <div className='AddMembership'>
                            All users may also restrict individual elements of profile information by selecting for viewing those fields listed in the "My Privacy Settings" frame below.
                        </div>

                        <div className='AddMembership'>
                            Scouting America's Privacy Policy describes the types of information Scouting America collects, how Scouting America may use and disclose such information, and user's ability to control certain uses of it.  The Privacy Policy is found at <a href="https://www.scouting.org/legal/privacy-policy/">https://www.scouting.org/legal/privacy-policy/</a>
                        </div>

                        <span className='span-heading'>
                            The below settings reflect your personal information that will be available for viewing by Spark users.
                        </span>
                        {state.isLoadingPrivacySettings &&
                            <Col span={24} className='content-center'>
                                <Row type='flex' align='center' justify='center'>
                                    <Spin tip="Loading Privacy Information..."></Spin>
                                </Row>
                            </Col>
                        }
                        {state.alumniPrivacyOptionsState && <div>
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>

                                    <FormItem label={""}>
                                        {getFieldDecorator('isNameDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isNameDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isNameDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isNameDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Name</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isAddressLineDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isAddressLineDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isAddressLineDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isAddressLineDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Address (Primary)</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isCityStateZipDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isCityStateZipDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isCityStateZipDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isCityStateZipDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                City, State, Zip Code</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isTelephoneDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isTelephoneDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isTelephoneDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isTelephoneDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Telephone Number (primary)</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isEmailDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEmailDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEmailDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isEmailDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Email address (primary)</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isEagleCouncilNameDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleCouncilNameDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleCouncilNameDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isEagleCouncilNameDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Eagle Council Name</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isEagleUnitNumberDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleUnitNumberDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleUnitNumberDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isEagleUnitNumberDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Eagle Unit Number</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isEagleUnitCityDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleUnitCityDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleUnitCityDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isEagleUnitCityDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Eagle Unit City</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isEagleUnitStateDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleUnitStateDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEagleUnitStateDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isEagleUnitStateDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Eagle Unit State</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isScoutingAffiliationsDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isScoutingAffiliationsDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isScoutingAffiliationsDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isScoutingAffiliationsDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Scouting Affiliations</Checkbox>
                                        )}
                                    </FormItem>
                                    <div className='span-heading' style={{ display: 'block', margin: '8px 0 4px' }}>
                                        Do Not Contact
                                    </div>
                                    <FormItem label={""}>
                                        {getFieldDecorator('sparkDirectoryOptOut', {
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.sparkDirectoryOptOut : ""}
                                                onChange={(e) => changePrivacyOption(e, 'sparkDirectoryOptOut')}
                                                disabled={props.viewableOnly}
                                            >
                                                Spark: Directory of Scouting Alumni</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('scoutingAmericaOptOut', {
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.scoutingAmericaOptOut : ""}
                                                onChange={(e) => changePrivacyOption(e, 'scoutingAmericaOptOut')}
                                                disabled={props.viewableOnly}
                                            >
                                                Scouting America</Checkbox>
                                        )}
                                    </FormItem>
                                </Col>

                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    
                                    <FormItem label={""}>
                                        {getFieldDecorator('isMembershipTypeDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isMembershipTypeDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isMembershipTypeDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isMembershipTypeDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Membership Type</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isMembershipStatusDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isMembershipStatusDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isMembershipStatusDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isMembershipStatusDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                Membership Status</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isCouncilAffiliationsDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isCouncilAffiliationsDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isCouncilAffiliationsDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isCouncilAffiliationsDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Council Affiliations</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isHobbiesAndInterestsDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isHobbiesAndInterestsDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isHobbiesAndInterestsDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isHobbiesAndInterestsDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Hobbies & Interest</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isOccupationDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isOccupationDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isOccupationDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isOccupationDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Business & Career</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isWebContactsDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isWebContactsDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isWebContactsDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isWebContactsDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Social Media Accounts</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isEmployerDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEmployerDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isEmployerDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isEmployerDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Employer</Checkbox>
                                        )}
                                    </FormItem>
                                        <FormItem label={""}>
                                            {getFieldDecorator('isNationalAwardsDisplayed', {
                                                // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isNationalAwardsDisplayed : false,
                                                rules: [{ required: false }],
                                            })(
                                                <Checkbox
                                                    checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isNationalAwardsDisplayed : ""}
                                                    onChange={(e) => changePrivacyOption(e, 'isNationalAwardsDisplayed')}
                                                    disabled={props.viewableOnly}
                                                >
                                                    My National Awards</Checkbox>
                                            )}
                                        </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isLocalAwardsDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isLocalAwardsDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isLocalAwardsDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isLocalAwardsDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Local Awards</Checkbox>
                                        )}
                                    </FormItem>
                                    <FormItem label={""}>
                                        {getFieldDecorator('isAffinityGroupsDisplayed', {
                                            // initialValue: state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isAffinityGroupsDisplayed : false,
                                            rules: [{ required: false }],
                                        })(
                                            <Checkbox
                                                checked={state.alumniPrivacyOptionsState ? state.alumniPrivacyOptionsState.isAffinityGroupsDisplayed : ""}
                                                onChange={(e) => changePrivacyOption(e, 'isAffinityGroupsDisplayed')}
                                                disabled={props.viewableOnly}
                                            >
                                                My Affinity Groups</Checkbox>
                                        )}
                                    </FormItem>
                                </Col>
                            </Row>
                            {/* <hr></hr> */}

                            {!props.viewableOnly && <div>
                                <FormItem label={""} className='span-heading'>
                                    {getFieldDecorator('confirmationBox', {
                                        // rules: [{ required: true, message: 'Please confirm it before saving the changes!' }],
                                    })(
                                        <Checkbox
                                            // onChange={(e) => changePrivacyOption(e, 'confirmationBox')}
                                            // checked={state.enableSaveBtn}
                                            disabled={!state.needToUpdate}
                                            style={{ letterSpacing: '0.5px' }}
                                            onChange={(e) => dispatch({type: 'enableSaveBtnState', enableSaveBtn: e.target.checked})}
                                        >
                                            With this checkbox you are allowing Scouting America Alumni Directory to publicly display the approved information as part of any public export file.</Checkbox>
                                    )}
                                </FormItem>
                                <Row type='flex' className='btn-action m-t-20' justify='space-around'>
                                    <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                        <Row type='flex' justify='space-around'>
                                            {/* <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                            <FormItem>
                                                <Button onClick={() => this.cancelActions()} className="myprofile-cancel-btn" >CANCEL</Button>
                                            </FormItem>
                                        </Col> */}
                                            <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                                <FormItem>
                                                    <Button className={state.enableSaveBtn ? "save-change-btn" : "save-change-btn input-disabled"} 
                                                    style={{ border: !state.enableSaveBtn ? 'none' : '' }}
                                                    htmlType="submit" disabled={!state.enableSaveBtn} loading={props.isUpdating} type="primary">SAVE CHANGES</Button>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </Form>
            </Row>

        </div>
    );
};



const mapStateToProps = (state) => ({
    privacysettingsOptions: state.alumniPrivacyOptionsreducer.privacysettingsOptions,
    isLoadingPrivacySettings: state.alumniPrivacyOptionsreducer.loading,
    profileinfo: state.profilereducer.profileinfo,
    isUpdating: state.updatePrivacysettingsreducer.isUpdating,
});

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

const AlumniPrivacyOptions = Form.create({ name: "alumniPrivacyOptions" })(AlumniPrivacyOptionsComponent);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlumniPrivacyOptions));



// WEBPACK FOOTER //
// ./src/components/Inc/AlumniPrivacyOptions.js